const workspaceLanguage: Record<string, Record<string, string>> = {
  'en-US': {
    workspace_switch: 'Workspace',
    workspace_meetings: 'Meetings',
    workspace_agent: 'Agent',
    assistant_panel_open: 'Open Meeting Assistant',
    assistant_panel_close: 'Collapse Meeting Assistant',
    assistant_panel_resize: 'Resize home and Meeting Assistant panels',
    assistant_recent_chats: 'Recent chats',
    assistant_panel_history: 'History',
    assistant_history_see_all: 'See all',
    assistant_history_back: 'Back to chat',
    assistant_delete_running: 'Stop the running reply before deleting this chat.',
    assistant_history_loading: 'Loading chats…',
    assistant_history_empty: 'No chats yet',
    assistant_history_error: 'Could not refresh recent chats.',
    assistant_running_elsewhere: 'A reply is still running in another chat. Return to it or stop it before sending here.',
    assistant_open_running: 'Return to running chat',
    assistant_stop_response: 'Stop response',
    assistant_stop_retry: 'Retry stopping',
    assistant_preparing_elsewhere: 'Another chat is preparing a reply. You can send here once it finishes.',
  },
  'zh-CN': {
    workspace_switch: '工作区',
    workspace_meetings: '会议',
    workspace_agent: '智能体',
    assistant_panel_open: '打开会议助手',
    assistant_panel_close: '收起会议助手',
    assistant_panel_resize: '调整首页和会议助手面板宽度',
    assistant_recent_chats: '最近对话',
    assistant_panel_history: '历史记录',
    assistant_history_see_all: '查看全部',
    assistant_history_back: '返回对话',
    assistant_delete_running: '请先停止正在生成的回复，再删除此对话。',
    assistant_history_loading: '正在加载对话…',
    assistant_history_empty: '暂无对话',
    assistant_history_error: '无法刷新最近对话。',
    assistant_running_elsewhere: '另一段对话仍在生成回复。请返回该对话或停止生成后再发送。',
    assistant_open_running: '返回正在生成的对话',
    assistant_stop_response: '停止回复',
    assistant_stop_retry: '重试停止',
    assistant_preparing_elsewhere: '另一段对话正在准备回复。完成后即可在此发送。',
  },
  'zh-HK': {
    workspace_switch: '工作區',
    workspace_meetings: '會議',
    workspace_agent: '智能體',
    assistant_panel_open: '開啟會議助手',
    assistant_panel_close: '收起會議助手',
    assistant_panel_resize: '調整首頁和會議助手面板寬度',
    assistant_recent_chats: '最近對話',
    assistant_panel_history: '歷史記錄',
    assistant_history_see_all: '查看全部',
    assistant_history_back: '返回對話',
    assistant_delete_running: '請先停止正在產生的回覆，再刪除此對話。',
    assistant_history_loading: '正在載入對話…',
    assistant_history_empty: '暫無對話',
    assistant_history_error: '無法更新最近對話。',
    assistant_running_elsewhere: '另一段對話仍在產生回覆。請返回該對話或停止產生後再傳送。',
    assistant_open_running: '返回正在產生回覆的對話',
    assistant_stop_response: '停止回覆',
    assistant_stop_retry: '重試停止',
    assistant_preparing_elsewhere: '另一段對話正在準備回覆。完成後即可在此傳送。',
  },
};

export default workspaceLanguage;
